/**
 * Language utilities.
 */

interface TranscriptionLanguage {
  value: string;
  name: string;
  isVocab: boolean;
  isLive: boolean;
}

interface TranslationLanguage {
  code: string;
  language: string;
  transcriptionCode: string;
  isDubbing: boolean;
}

export const TRANSCRIPTION_LANGUAGES: TranscriptionLanguage[] = [
  { value: "en-US", name: "English (US)", isVocab: true, isLive: true },
  { value: "en-AU", name: "English (Australia)", isVocab: true, isLive: true },
  { value: "en-GB", name: "English (British)", isVocab: true, isLive: true },
  { value: "en-IN", name: "English (Indian)", isVocab: true, isLive: true },
  { value: "en-IE", name: "English (Irish)", isVocab: true, isLive: true },
  {
    value: "en-NZ",
    name: "English (New Zealand)",
    isVocab: true,
    isLive: true,
  },
  { value: "en-AB", name: "English (Scottish)", isVocab: true, isLive: true },
  {
    value: "en-ZA",
    name: "English (South African)",
    isVocab: true,
    isLive: true,
  },
  { value: "fr-FR", name: "French", isVocab: true, isLive: true },
  { value: "fr-CA", name: "French (Canada)", isVocab: true, isLive: true },
  { value: "es-ES", name: "Spanish", isVocab: true, isLive: true },
  { value: "es-MX", name: "Spanish (Mexico)", isVocab: false, isLive: true },
  { value: "ab-GE", name: "Abkhaz", isVocab: false, isLive: false },
  { value: "af-ZA", name: "Afrikaans", isVocab: false, isLive: false },
  { value: "hy-AM", name: "Armenian", isVocab: false, isLive: false },
  { value: "ar-AE", name: "Arabic (U.A.E.)", isVocab: false, isLive: false },
  { value: "ar-BH", name: "Arabic (Bahrain)", isVocab: false, isLive: false },
  { value: "ar-EG", name: "Arabic (Egypt)", isVocab: false, isLive: false },
  { value: "ar-IL", name: "Arabic (Israel)", isVocab: false, isLive: false },
  { value: "ar-IQ", name: "Arabic (Iraq)", isVocab: false, isLive: false },
  { value: "ar-JO", name: "Arabic (Jordan)", isVocab: false, isLive: false },
  { value: "ar-KW", name: "Arabic (Kuwait)", isVocab: false, isLive: false },
  { value: "ar-LB", name: "Arabic (Lebanon)", isVocab: false, isLive: false },
  { value: "ar-OM", name: "Arabic (Oman)", isVocab: false, isLive: false },
  {
    value: "ar-PS",
    name: "Arabic (Palestinian Authority)",
    isVocab: false,
    isLive: false,
  },
  { value: "ar-QA", name: "Arabic (Qatar)", isVocab: false, isLive: false },
  {
    value: "ar-SA",
    name: "Arabic (Saudi Arabia)",
    isVocab: false,
    isLive: false,
  },
  {
    value: "ar-SY",
    name: "Arabic Syrian Arab Republic",
    isVocab: false,
    isLive: false,
  },
  { value: "as-IN", name: "Assamese (India)", isVocab: false, isLive: false },
  { value: "ast-ES", name: "Asturian", isVocab: false, isLive: false },
  { value: "ba-RU", name: "Bashkir", isVocab: false, isLive: false },
  { value: "eu-ES", name: "Basque", isVocab: false, isLive: false },
  { value: "be-BY", name: "Belarusian", isVocab: false, isLive: false },
  { value: "bn-IN", name: "Bengali (India)", isVocab: false, isLive: false },
  { value: "bs-BA", name: "Bosnian", isVocab: false, isLive: false },
  { value: "bg-BG", name: "Bulgarian", isVocab: true, isLive: true },
  { value: "ca-ES", name: "Catalan", isVocab: true, isLive: true },
  {
    value: "ckb-IR",
    name: "Central Kurdish, Iran",
    isVocab: false,
    isLive: false,
  },
  {
    value: "ckb-IQ",
    name: "Central Kurdish, Iraq",
    isVocab: false,
    isLive: false,
  },
  { value: "zh-CN", name: "Chinese (Simplified)", isVocab: true, isLive: true },
  {
    value: "zh-TW",
    name: "Chinese (Traditional)",
    isVocab: true,
    isLive: true,
  },
  {
    value: "zh-HK",
    name: "Chinese (Cantonese, Traditional)",
    isVocab: false,
    isLive: true,
  },
  { value: "hr-HR", name: "Croatian", isVocab: false, isLive: false },
  { value: "cs-CZ", name: "Czech", isVocab: true, isLive: true },
  { value: "da-DK", name: "Danish", isVocab: true, isLive: true },
  { value: "nl-NL", name: "Dutch", isVocab: true, isLive: true },
  { value: "et-EE", name: "Estonian", isVocab: false, isLive: true },
  { value: "fa-IR", name: "Farsi", isVocab: false, isLive: false },
  { value: "nl-BE", name: "Flemish", isVocab: false, isLive: true },
  { value: "fi-FI", name: "Finnish", isVocab: true, isLive: true },
  { value: "gl-ES", name: "Galician", isVocab: false, isLive: false },
  { value: "ka-GE", name: "Georgian", isVocab: false, isLive: false },
  { value: "de-CH", name: "German (Swiss)", isVocab: false, isLive: true },
  { value: "de-DE", name: "German", isVocab: true, isLive: true },
  { value: "el-GR", name: "Greek", isVocab: false, isLive: true },
  { value: "gu-IN", name: "Gujarati", isVocab: true, isLive: false },
  { value: "ha-NG", name: "Hausa", isVocab: false, isLive: false },
  { value: "he-IL", name: "Hebrew", isVocab: false, isLive: false },
  { value: "hi-IN", name: "Hindi", isVocab: true, isLive: true },
  { value: "hi-Latn", name: "Hindi (Latin)", isVocab: false, isLive: true },
  { value: "hu-HU", name: "Hungarian", isVocab: false, isLive: true },
  { value: "is-IS", name: "Icelandic", isVocab: false, isLive: false },
  { value: "ga-IE", name: "Irish", isVocab: false, isLive: false },
  { value: "kab-DZ", name: "Kabyle", isVocab: false, isLive: false },
  { value: "id-ID", name: "Indonesian", isVocab: false, isLive: true },
  { value: "it-IT", name: "Italian", isVocab: true, isLive: true },
  { value: "ja-JP", name: "Japanese", isVocab: true, isLive: true },
  { value: "kn-IN", name: "Kannada", isVocab: false, isLive: false },
  { value: "ko-KR", name: "Korean", isVocab: true, isLive: true },
  { value: "lt-LT", name: "Lithuanian", isVocab: false, isLive: true },
  { value: "lv-LV", name: "Latvian", isVocab: false, isLive: true },
  { value: "ml-IN", name: "Malayalam", isVocab: false, isLive: false },
  { value: "mk-MK", name: "Macedonian", isVocab: false, isLive: false },
  { value: "ms-MY", name: "Malay", isVocab: true, isLive: true },
  { value: "nb-NO", name: "Norwegian", isVocab: false, isLive: true },
  { value: "pl-PL", name: "Polish", isVocab: true, isLive: true },
  {
    value: "pt-BR",
    name: "Portuguese (Brazilian)",
    isVocab: false,
    isLive: true,
  },
  {
    value: "pt-PT",
    name: "Portuguese (Portugal)",
    isVocab: false,
    isLive: true,
  },
  { value: "ro-RO", name: "Romanian", isVocab: true, isLive: true },
  { value: "ru-RU", name: "Russian", isVocab: true, isLive: true },
  { value: "sk-SK", name: "Slovak", isVocab: false, isLive: true },
  { value: "sl-SI", name: "Slovenian", isVocab: false, isLive: false },
  { value: "sv-SE", name: "Swedish", isVocab: false, isLive: true },
  { value: "taq", name: "Tamasheq", isVocab: false, isLive: true },
  { value: "ta-IN", name: "Tamil", isVocab: false, isLive: false },
  { value: "te-IN", name: "Telugu", isVocab: false, isLive: false },
  { value: "th-TH", name: "Thai", isVocab: false, isLive: true },
  { value: "tr-TR", name: "Turkish", isVocab: true, isLive: true },
  { value: "uk-UA", name: "Ukrainian", isVocab: false, isLive: true },
  { value: "vi-VN", name: "Vietnamese", isVocab: true, isLive: true },
  { value: "yi-XX", name: "Yiddish", isVocab: false, isLive: false },
  { value: "auto", name: "Automatic", isVocab: false, isLive: false },
  { value: "multi", name: "Multiple", isVocab: false, isLive: true },
];

export const TRANSCRIPTION_LANGUAGE_OPTIONS = TRANSCRIPTION_LANGUAGES.map(
  (l) => ({
    code: l.value,
    name: l.name,
    isVocab: l.isVocab,
    isLive: l.isLive,
  }),
);

export const TRANSLATION_LANGUAGES: TranslationLanguage[] = [
  {
    code: "en",
    language: "English",
    transcriptionCode: "en-US",
    isDubbing: true,
  },
  {
    code: "fr",
    language: "French",
    transcriptionCode: "fr-FR",
    isDubbing: true,
  },
  {
    code: "af",
    language: "Afrikaans",
    transcriptionCode: "af-ZA",
    isDubbing: false,
  },
  {
    code: "ar",
    language: "Arabic",
    transcriptionCode: "ar-SA",
    isDubbing: true,
  },
  {
    code: "hy",
    language: "Armenian",
    transcriptionCode: "hy-AM",
    isDubbing: false,
  },
  {
    code: "bg",
    language: "Bulgarian",
    transcriptionCode: "bg-BG",
    isDubbing: true,
  },
  {
    code: "ca",
    language: "Catalan",
    transcriptionCode: "ca-ES",
    isDubbing: false,
  },
  {
    code: "hr",
    language: "Croatian",
    transcriptionCode: "hr-HR",
    isDubbing: true,
  },
  {
    code: "cs",
    language: "Czech",
    transcriptionCode: "cs-CZ",
    isDubbing: true,
  },
  {
    code: "da",
    language: "Danish",
    transcriptionCode: "da-DK",
    isDubbing: true,
  },
  {
    code: "nl",
    language: "Dutch",
    transcriptionCode: "nl-NL",
    isDubbing: true,
  },
  {
    code: "et",
    language: "Estonian",
    transcriptionCode: "et-EE",
    isDubbing: false,
  },
  {
    code: "fa",
    language: "Farsi",
    transcriptionCode: "fa-IR",
    isDubbing: false,
  },
  {
    code: "fi",
    language: "Finnish",
    transcriptionCode: "fi-FI",
    isDubbing: true,
  },
  {
    code: "de",
    language: "German",
    transcriptionCode: "de-DE",
    isDubbing: true,
  },
  {
    code: "el",
    language: "Greek",
    transcriptionCode: "el-GR",
    isDubbing: true,
  },
  {
    code: "gu",
    language: "Gujarati",
    transcriptionCode: "gu-IN",
    isDubbing: false,
  },
  {
    code: "he",
    language: "Hebrew",
    transcriptionCode: "he-IL",
    isDubbing: false,
  },
  {
    code: "hi",
    language: "Hindi",
    transcriptionCode: "hi-IN",
    isDubbing: true,
  },
  {
    code: "ht",
    language: "Haitian Creole",
    transcriptionCode: "ht-HT",
    isDubbing: false,
  },
  {
    code: "hu",
    language: "Hungarian",
    transcriptionCode: "hu-HU",
    isDubbing: false,
  },
  {
    code: "id",
    language: "Indonesian",
    transcriptionCode: "id-ID",
    isDubbing: true,
  },
  {
    code: "is",
    language: "Icelandic",
    transcriptionCode: "is-IS",
    isDubbing: false,
  },
  {
    code: "it",
    language: "Italian",
    transcriptionCode: "it-IT",
    isDubbing: true,
  },
  {
    code: "ga",
    language: "Irish",
    transcriptionCode: "ga-IE",
    isDubbing: false,
  },
  {
    code: "ja",
    language: "Japanese",
    transcriptionCode: "ja-JP",
    isDubbing: true,
  },
  {
    code: "kn",
    language: "Kannada",
    transcriptionCode: "kn-IN",
    isDubbing: false,
  },
  {
    code: "ko",
    language: "Korean",
    transcriptionCode: "ko-KR",
    isDubbing: true,
  },
  {
    code: "lt",
    language: "Lithuanian",
    transcriptionCode: "lt-LT",
    isDubbing: false,
  },
  {
    code: "lv",
    language: "Latvian",
    transcriptionCode: "lv-LV",
    isDubbing: false,
  },
  {
    code: "ml",
    language: "Malayalam",
    transcriptionCode: "ml-IN",
    isDubbing: false,
  },
  {
    code: "ms",
    language: "Malay",
    transcriptionCode: "ms-MY",
    isDubbing: true,
  },
  {
    code: "no",
    language: "Norwegian",
    transcriptionCode: "nb-NO",
    isDubbing: false,
  },
  {
    code: "pl",
    language: "Polish",
    transcriptionCode: "pl-PL",
    isDubbing: true,
  },
  {
    code: "pt",
    language: "Portuguese",
    transcriptionCode: "pt-PT",
    isDubbing: true,
  },
  {
    code: "ro",
    language: "Romanian",
    transcriptionCode: "ro-RO",
    isDubbing: true,
  },
  {
    code: "ru",
    language: "Russian",
    transcriptionCode: "ru-RU",
    isDubbing: true,
  },
  {
    code: "es",
    language: "Spanish",
    transcriptionCode: "es-ES",
    isDubbing: true,
  },
  {
    code: "sk",
    language: "Slovak",
    transcriptionCode: "sk-SK",
    isDubbing: true,
  },
  {
    code: "sl",
    language: "Slovenian",
    transcriptionCode: "sl-SI",
    isDubbing: false,
  },
  {
    code: "sv",
    language: "Swedish",
    transcriptionCode: "sv-SE",
    isDubbing: true,
  },
  {
    code: "ta",
    language: "Tamil",
    transcriptionCode: "ta-IN",
    isDubbing: true,
  },
  {
    code: "te",
    language: "Telugu",
    transcriptionCode: "te-IN",
    isDubbing: false,
  },
  {
    code: "th",
    language: "Thai",
    transcriptionCode: "th-TH",
    isDubbing: false,
  },
  {
    code: "tr",
    language: "Turkish",
    transcriptionCode: "tr-TR",
    isDubbing: true,
  },
  {
    code: "uk",
    language: "Ukrainian",
    transcriptionCode: "uk-UA",
    isDubbing: true,
  },
  {
    code: "vi",
    language: "Vietnamese",
    transcriptionCode: "vi-VN",
    isDubbing: false,
  },
  {
    code: "as",
    language: "Assamese",
    transcriptionCode: "as-IN",
    isDubbing: false,
  },
  {
    code: "ay",
    language: "Aymara",
    transcriptionCode: "ay-BO",
    isDubbing: false,
  },
  {
    code: "bm",
    language: "Bambara",
    transcriptionCode: "bm-ML",
    isDubbing: false,
  },
  {
    code: "eu",
    language: "Basque",
    transcriptionCode: "eu-ES",
    isDubbing: false,
  },
  {
    code: "be",
    language: "Belarusian",
    transcriptionCode: "be-BY",
    isDubbing: false,
  },
  {
    code: "bho",
    language: "Bhojpuri",
    transcriptionCode: "bho-IN",
    isDubbing: false,
  },
  {
    code: "ceb",
    language: "Cebuano",
    transcriptionCode: "ceb-PH",
    isDubbing: false,
  },
  {
    code: "co",
    language: "Corsican",
    transcriptionCode: "co-FR",
    isDubbing: false,
  },
  {
    code: "dv",
    language: "Dhivehi",
    transcriptionCode: "dv-MV",
    isDubbing: false,
  },
  {
    code: "doi",
    language: "Dogri",
    transcriptionCode: "doi-IN",
    isDubbing: false,
  },
  {
    code: "eo",
    language: "Esperanto",
    transcriptionCode: "eo-XX",
    isDubbing: false,
  },
  { code: "ee", language: "Ewe", transcriptionCode: "ee-GH", isDubbing: false },
  {
    code: "fil",
    language: "Filipino (Tagalog)",
    transcriptionCode: "fil-PH",
    isDubbing: true,
  },
  {
    code: "fy",
    language: "Frisian",
    transcriptionCode: "fy-NL",
    isDubbing: false,
  },
  {
    code: "gl",
    language: "Galician",
    transcriptionCode: "gl-ES",
    isDubbing: false,
  },
  {
    code: "gn",
    language: "Guarani",
    transcriptionCode: "gn-PY",
    isDubbing: false,
  },
  {
    code: "haw",
    language: "Hawaiian",
    transcriptionCode: "haw-US",
    isDubbing: false,
  },
  {
    code: "hmn",
    language: "Hmong",
    transcriptionCode: "hmn-CN",
    isDubbing: false,
  },
  {
    code: "ig",
    language: "Igbo",
    transcriptionCode: "ig-NG",
    isDubbing: false,
  },
  {
    code: "ilo",
    language: "Ilocano",
    transcriptionCode: "ilo-PH",
    isDubbing: false,
  },
  {
    code: "jv",
    language: "Javanese",
    transcriptionCode: "jv-ID",
    isDubbing: false,
  },
  {
    code: "km",
    language: "Khmer",
    transcriptionCode: "km-KH",
    isDubbing: false,
  },
  {
    code: "rw",
    language: "Kinyarwanda",
    transcriptionCode: "rw-RW",
    isDubbing: false,
  },
  {
    code: "gom",
    language: "Konkani",
    transcriptionCode: "gom-IN",
    isDubbing: false,
  },
  {
    code: "kri",
    language: "Krio",
    transcriptionCode: "kri-SL",
    isDubbing: false,
  },
  {
    code: "ku",
    language: "Kurdish",
    transcriptionCode: "ku-TR",
    isDubbing: false,
  },
  {
    code: "ckb",
    language: "Kurdish (Sorani)",
    transcriptionCode: "ckb-IQ",
    isDubbing: false,
  },
  {
    code: "ky",
    language: "Kyrgyz",
    transcriptionCode: "ky-KG",
    isDubbing: false,
  },
  { code: "lo", language: "Lao", transcriptionCode: "lo-LA", isDubbing: false },
  {
    code: "la",
    language: "Latin",
    transcriptionCode: "la-VA",
    isDubbing: false,
  },
  {
    code: "ln",
    language: "Lingala",
    transcriptionCode: "ln-CG",
    isDubbing: false,
  },
  {
    code: "lg",
    language: "Luganda",
    transcriptionCode: "lg-UG",
    isDubbing: false,
  },
  {
    code: "lb",
    language: "Luxembourgish",
    transcriptionCode: "lb-LU",
    isDubbing: false,
  },
  {
    code: "mai",
    language: "Maithili",
    transcriptionCode: "mai-IN",
    isDubbing: false,
  },
  {
    code: "mg",
    language: "Malagasy",
    transcriptionCode: "mg-MG",
    isDubbing: false,
  },
  {
    code: "mi",
    language: "Maori",
    transcriptionCode: "mi-NZ",
    isDubbing: false,
  },
  {
    code: "mni-Mtei",
    language: "Meiteilon (Manipuri)",
    transcriptionCode: "mni-IN",
    isDubbing: false,
  },
  {
    code: "lus",
    language: "Mizo",
    transcriptionCode: "lus-IN",
    isDubbing: false,
  },
  {
    code: "my",
    language: "Myanmar (Burmese)",
    transcriptionCode: "my-MM",
    isDubbing: false,
  },
  {
    code: "ne",
    language: "Nepali",
    transcriptionCode: "ne-NP",
    isDubbing: false,
  },
  {
    code: "ny",
    language: "Nyanja (Chichewa)",
    transcriptionCode: "ny-MW",
    isDubbing: false,
  },
  {
    code: "or",
    language: "Odia (Oriya)",
    transcriptionCode: "or-IN",
    isDubbing: false,
  },
  {
    code: "om",
    language: "Oromo",
    transcriptionCode: "om-ET",
    isDubbing: false,
  },
  {
    code: "qu",
    language: "Quechua",
    transcriptionCode: "qu-PE",
    isDubbing: false,
  },
  {
    code: "sm",
    language: "Samoan",
    transcriptionCode: "sm-WS",
    isDubbing: false,
  },
  {
    code: "sa",
    language: "Sanskrit",
    transcriptionCode: "sa-IN",
    isDubbing: false,
  },
  {
    code: "gd",
    language: "Scots Gaelic",
    transcriptionCode: "gd-GB",
    isDubbing: false,
  },
  {
    code: "nso",
    language: "Sepedi",
    transcriptionCode: "nso-ZA",
    isDubbing: false,
  },
  {
    code: "st",
    language: "Sesotho",
    transcriptionCode: "st-ZA",
    isDubbing: false,
  },
  {
    code: "sn",
    language: "Shona",
    transcriptionCode: "sn-ZW",
    isDubbing: false,
  },
  {
    code: "sd",
    language: "Sindhi",
    transcriptionCode: "sd-PK",
    isDubbing: false,
  },
  {
    code: "si",
    language: "Sinhala (Sinhalese)",
    transcriptionCode: "si-LK",
    isDubbing: false,
  },
  {
    code: "su",
    language: "Sundanese",
    transcriptionCode: "su-ID",
    isDubbing: false,
  },
  {
    code: "tg",
    language: "Tajik",
    transcriptionCode: "tg-TJ",
    isDubbing: false,
  },
  {
    code: "tt",
    language: "Tatar",
    transcriptionCode: "tt-RU",
    isDubbing: false,
  },
  {
    code: "ti",
    language: "Tigrinya",
    transcriptionCode: "ti-ER",
    isDubbing: false,
  },
  {
    code: "ts",
    language: "Tsonga",
    transcriptionCode: "ts-ZA",
    isDubbing: false,
  },
  {
    code: "tk",
    language: "Turkmen",
    transcriptionCode: "tk-TM",
    isDubbing: false,
  },
  {
    code: "ak",
    language: "Twi (Akan)",
    transcriptionCode: "ak-GH",
    isDubbing: false,
  },
  {
    code: "ug",
    language: "Uyghur",
    transcriptionCode: "ug-CN",
    isDubbing: false,
  },
  {
    code: "xh",
    language: "Xhosa",
    transcriptionCode: "xh-ZA",
    isDubbing: false,
  },
  {
    code: "yi",
    language: "Yiddish",
    transcriptionCode: "yi-XX",
    isDubbing: false,
  },
  {
    code: "yo",
    language: "Yoruba",
    transcriptionCode: "yo-NG",
    isDubbing: false,
  },
  {
    code: "zu",
    language: "Zulu",
    transcriptionCode: "zu-ZA",
    isDubbing: false,
  },
];

// Build lookup maps for O(1) access
const transcriptionByCode = new Map<string, string>(
  TRANSCRIPTION_LANGUAGES.map((l) => [l.value, l.name]),
);

const transcriptionByName = new Map<string, string>(
  TRANSCRIPTION_LANGUAGES.map((l) => [l.name.toLowerCase(), l.value]),
);

const translationByTranscriptionCode = new Map<string, string>(
  TRANSLATION_LANGUAGES.map((l) => [l.transcriptionCode, l.language]),
);

const translationByLanguageName = new Map<string, string>(
  TRANSLATION_LANGUAGES.map((l) => [
    l.language.toLowerCase(),
    l.transcriptionCode,
  ]),
);

/**
 * Get the display name for a language code.
 * Checks transcription languages first, then falls back to translation languages.
 * Replaces: LanguageSelectorPipe (non-translation mode)
 *
 * @param code - Language code (e.g. 'en-US', 'fr-FR')
 * @returns Human-readable language name, or the code itself if not found
 */
export function getLanguageName(code: string): string {
  if (!code) return "";

  // Check transcription languages first (exact match on value)
  const transcriptionName = transcriptionByCode.get(code);
  if (transcriptionName) return transcriptionName;

  // Fall back to translation languages (match on transcriptionCode)
  const translationName = translationByTranscriptionCode.get(code);
  if (translationName) return translationName;

  return code;
}

/**
 * Get a language code from a language name.
 * Checks transcription languages first, then translation languages.
 *
 * @param name - Language name (e.g. 'English (US)', 'French')
 * @returns Language code (e.g. 'en-US', 'fr-FR'), or the name itself if not found
 */
export function getLanguageCode(name: string): string {
  if (!name) return "";

  const lower = name.toLowerCase();

  // Check transcription languages first
  const transcriptionCode = transcriptionByName.get(lower);
  if (transcriptionCode) return transcriptionCode;

  // Fall back to translation languages
  const translationCode = translationByLanguageName.get(lower);
  if (translationCode) return translationCode;

  return name;
}

const PRIMARY_DEFAULTS: Record<string, string> = {
  en: "en-US",
  fr: "fr-FR",
  es: "es-ES",
  ar: "ar-SA",
  zh: "zh-CN",
  de: "de-DE",
  pt: "pt-BR",
};

export function matchNavigatorLanguage(
  nav: string,
  list: { code: string }[],
): string | null {
  if (!nav || !list.length) return null;
  const navLower = nav.toLowerCase();
  const exact = list.find((l) => l.code.toLowerCase() === navLower);
  if (exact) return exact.code;
  const navPrimary = navLower.split("-")[0];
  const preferred = PRIMARY_DEFAULTS[navPrimary];
  if (preferred) {
    const match = list.find((l) => l.code === preferred);
    if (match) return match.code;
  }
  const prefix = list.find((l) =>
    l.code.toLowerCase().startsWith(navPrimary + "-"),
  );
  if (prefix) return prefix.code;
  return null;
}

export function resolveMeetingLanguage(code?: string | null): string {
  return code && code !== "auto" ? code : "en-US";
}

export function resolveDefaultSourceLanguage(
  existing: string | null | undefined,
  languages: { code: string }[],
  navLanguage: string,
): string {
  const existingValid =
    existing && languages.some((l) => l.code === existing) ? existing : null;
  return existingValid ?? matchNavigatorLanguage(navLanguage, languages) ?? "en-US";
}
